import React, { Component } from 'react'
import { connect } from 'react-redux';
import { setFilter } from '../../actions/filters'

// UI component for dropdown.
const StatusDropdown = ({ value, handleChange }) => (

    <select value={value}
        className="form-control"
        onChange={handleChange}
    >
        <option value="">Search status</option>
        <option value="1">Active</option>
        <option value="0">Inactive</option>
    </select>

)

// Actual class
class BooleanFilter extends Component {
    constructor(props) {
        super(props)
        this.state = {
            input1: ''
        }
        this.handleStatusDropdown = this.handleStatusDropdown.bind(this)
        this.clearFilter = this.clearFilter.bind(this)
    }

    clearFilter() {
        this.setState({
            input1: ''
        })
    }

    handleStatusDropdown(event) {

        let newInput = event.target.value.toString()

        this.setState({
            input1: newInput
        })
    }

    componentDidUpdate() {
        this.bindToState()
    }

    componentDidMount() {
        const getProps = this.props
        const getPreviousValue = this.props.value1.toString()

        this.setState({
            input1: getPreviousValue
        })

    }

    bindToState() {
        let filter = {}
        filter[this.props.filterName] = {
            type: "boolean",
            value1: this.state.input1.toString()
        }
        this.props.dispatch(setFilter(
            this.props.id,
            filter
        ))
    }

    render() {
        //let i1 = this.props.value1
        return (
            <div className="form-group">
                <StatusDropdown
                    value={this.state.input1}
                    handleChange={this.handleStatusDropdown}
                />
            </div>
        )
    }
}

export default connect(null, null, null, { withRef: true })(BooleanFilter)


// WEBPACK FOOTER //
// ./src/components/filters/booleanFilter.js